export const convertToEnglishNumber = (value, full = false) => {
  if (value === null || value === undefined) {
    return "";
  }

  let result = String(value)
    .replace(/[۰-۹٠-٩]/g, (char) => {
      const code = char.charCodeAt(0);

      return String(
        code >= 0x06f0
          ? code - 0x06f0
          : code - 0x0660
      );
    })

    // Arabic Decimal Separator
    .replace(/\u066B/g, ".")

    // Arabic Thousands Separator
    .replace(/\u066C/g, ",")

    // Persian/Arabic comma
    .replace(/\u060C/g, ",");

  if (full) {
    result = result.replace(/[^0-9]/g, "");
  }

  let str = result;

  if (!str) {
    return "";
  }
  if (/[^0-9۰-۹٠-٩.,]/.test(result)) {

    return result;
  }
  // تمام spaceها
  str = str.replace(/\s/g, "");

  // برای اطمینان از separatorهای مختلف
  str = str
    .replace(/[٬،]/g, ",")
    .replace(/٫/g, ".");

  const commaIndex = str.lastIndexOf(",");
  const dotIndex = str.lastIndexOf(".");

  // مثال: 1,234,567.89
  // یا:    1.234.567,89
  if (commaIndex !== -1 && dotIndex !== -1) {
    if (commaIndex > dotIndex) {
      // 1.234.567,89 => 1234567.89
      str = str
        .replace(/\./g, "")
        .replace(/,/g, (match, offset) =>
          offset === commaIndex ? "." : ""
        );
    } else {
      // 1,234,567.89 => 1234567.89
      str = str.replace(/,/g, "");
    }
  }

  // فقط comma
  else if (commaIndex !== -1) {
    const parts = str.split(",");

    // یک comma و حداکثر 2 رقم بعد آن => اعشار
    // 123,45 => 123.45
    if (
      parts.length === 2 &&
      parts[1].length > 0 &&
      parts[1].length <= 2
    ) {
      str = `${parts[0]}.${parts[1]}`;
    } else {
      // 123,456
      // 123,456,789
      str = str.replace(/,/g, "");
    }
  }

  return str;





};